import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import AppText from "../AppText";
import BackIcon from "../BackIcon";
import useRestList from "../../../_shared/hooks/useRestList";
import CloseIcon from "../CloseIcon";

// ----------------------------------------------------------------------------

export default function FinishesPage(props) {
  // -------------------------------------
  // Props Destructuring
  // -------------------------------------
  const [allFinishes] = useRestList("/finishes", null, {});
  const [allFabrics] = useRestList("/fabrics", null, {});

  const { onClose, finishes, fabrics } = props;

  // -------------------------------------
  // Hooks
  // -------------------------------------

  const [galleryOpen, setGalleryOpen] = useState(false);

  const [dataGallery, setDataGallery] = useState([]);

  const [initialIndex, setInitialIndex] = useState(0);

  const [finishesPage, setFinishesPage] = useState(finishes);
  const [fabricsPage, setFabricsPage] = useState(fabrics);

  const doneCategories = [];
  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    finishes
      ?.filter((fin) => !fin?.parentFinish)
      ?.map((mainCat) =>
        setFinishesPage([
          ...(finishesPage ?? []),
          ...(allFinishes?.rows?.filter(
            (x) => x?.parentFinish?._id === mainCat.id
          ) ?? []),
        ])
      );
  }, [allFinishes]);

  useEffect(() => {
    fabrics
      ?.filter((fin) => !fin?.parentFabric)
      ?.map((mainCat) =>
        setFabricsPage([
          ...(fabricsPage ?? []),
          ...(allFabrics?.rows?.filter(
            (x) => x?.parentFabric?._id === mainCat.id
          ) ?? []),
        ])
      );
  }, [allFabrics]);

  function saveCategory(x) {
    doneCategories.push(x);
  }

  function openGalleryFin(indexSel) {
    finishesPage?.map((subcat, index) =>
      indexSel.id === subcat.id ? setInitialIndex(index) : null
    );

    setDataGallery(finishesPage);
    setGalleryOpen(true);
  }
  function openGalleryFab(indexSel) {
    fabricsPage?.map((subcat, index) =>
      indexSel.id === subcat.id ? setInitialIndex(index) : null
    );

    setDataGallery(fabricsPage);
    setGalleryOpen(true);
  }
  return (
    <div>
      <div
        style={{
          alignSelf: "flex-end",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={styles.inline}>
          <div style={styles.inlineCenter}>
            <AppText bold big>
              Finiture e colori
            </AppText>

            <AppText light big>
              / Finishes and colours
            </AppText>
          </div>
        </div>
        <CloseIcon onClick={onClose}></CloseIcon>
      </div>
      <div>
        <div style={styles.centeredView}>
          {finishesPage
            ?.filter((finish) => finish?.parentFinish)
            .map((x) => {
              return x?.parentFinish === null ? (
                <div style={styles.subCard}>
                  <div onPress={() => openGalleryFin(x)}>
                    <img style={styles.subImage} source={x?.image} alt=""></img>
                    <AppText bold>{x?.name?.it}</AppText>
                    <AppText>{x?.description}</AppText>
                  </div>
                </div>
              ) : (
                doneCategories.indexOf(x?.parentFinish?.id) === -1 && (
                  <div style={styles.mainCard}>
                    <div style={{ marginBottom: 5, marginTop: 10 }}>
                      <AppText small bold>
                        {x?.parentFinish?.name?.it}
                      </AppText>
                      <AppText small light>
                        {x?.parentFinish?.name?.en}
                      </AppText>
                    </div>
                    {saveCategory(x?.parentFinish.id)}
                    <div style={styles.row}>
                      {finishesPage
                        .filter(
                          (parFin) =>
                            parFin?.parentFinish?.id === x?.parentFinish?.id
                        )
                        .map((fin) => (
                          <div style={styles.subCard}>
                            <div onPress={() => openGalleryFin(fin)}>
                              <img
                                style={styles.subImage}
                                src={fin?.image}
                                alt=""
                              ></img>

                              <AppText bold fin>
                                {fin?.code} {fin?.name?.it}
                              </AppText>
                              <AppText fin>{fin?.description}</AppText>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )
              );
              // );
            })}
          {fabricsPage
            ?.filter((fabric) => fabric?.parentFabric)
            ?.map((x) => {
              return (
                doneCategories.indexOf(x.parentFabric?.id) === -1 && (
                  <div style={styles.mainCard}>
                    <div style={{ marginBottom: 5, marginTop: 10 }}>
                      <AppText bold small>
                        {x.parentFabric?.name?.it}
                      </AppText>
                      <AppText small>{x.parentFabric?.name?.en}</AppText>
                    </div>
                    {saveCategory(x?.parentFabric.id)}
                    <div style={styles.row}>
                      {fabricsPage
                        .filter(
                          (parFin) =>
                            parFin?.parentFabric?.id === x.parentFabric?.id
                        )
                        .map((fin) => (
                          <div style={styles.subCard}>
                            <div onPress={() => openGalleryFab(fin)}>
                              <img
                                style={styles.subImage}
                                src={fin?.image}
                                alt=""
                              ></img>
                              <AppText bold small>
                                {fin?.name?.it}
                              </AppText>

                              <AppText small>{fin?.description}</AppText>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )
              );
              // );
            })}
        </div>
      </div>
    </div>
  );
}

// -------------------------------------
// Component PropTypes and default props
// -------------------------------------

const styles = {
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  detailText: {
    fontSize: 16,
  },
  detailImage: { width: 400, height: 450, marginBottom: 10 },
  mainCard: {
    marginBottom: 20,
  },

  subCard: {
    marginRight: 10,
  },
  subCardHandle: {
    marginRight: 40,
  },

  subTitleDescription: {
    fontSize: 10,
  },
  subImage: {
    width: 100,
    height: 130,
    resizeMode: "stretch",
  },
  inlineCenter: { display: "flex", flexDirection: "row", alignSelf: "center" },
  inline: { display: "flex", flexDirection: "row" },

  title: { fontSize: 30 },
};

// ----------------------------------------------------------------------------
